import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  IconButton,
  Input,
  InputAdornment,
  Switch,
  Tooltip,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import SearchInput from "../../components/SearchInput";

import DataTable from "react-data-table-component";
import CloseIcon from "@mui/icons-material/Close";

import { useNavigate } from "react-router-dom";
import contestmanagerapi from "../../services/contestmanager";
import errorHandler from "../../utils/errorHandler";
import { debounce } from "lodash";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { EditOutlined } from "@mui/icons-material";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import ViewBanner from "../banner/View";
import { Loader } from "../../components/CustomLoader";
import { Helmet } from "react-helmet-async";

const ListContestManager = () => {
  const navigate = useNavigate();
  const [searchItem, setSearchItem] = useState("");
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [status, setStatus] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loaderDelay, setLoaderDelay] = useState(false);
  const [show, setShow] = useState(false);
  const [warning, setWarning] = useState("");
  const [currentStatus, setCurrentStatus] = useState(null);
  const [statusId, setStatusId] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [viewId, setViewId] = useState("");
  const [isdelete, setisdelete] = useState(false);
  const [payload, setpayload] = useState({
    pageSize: 10,
    pageNumber: 1,
    searchItem: "",
    sortObject: { createdAt: -1 },
  });

  const fetchallcontest = async (query) => {
    const payload = {
      pageSize: pageSize,
      pageNumber: currentPage,
      searchItem: query || searchItem,
      sortObject: { createdAt: -1 },
    };

    try {
      setIsLoading(true);
      setLoaderDelay(false);
      const res = await contestmanagerapi.getAll(payload);

      setTimeout(() => {
        if (res.status === 200) {
          setData(res?.data?.data?.result);
          setTotalPages(res?.data?.data?.totalRecords);
        }
        setLoaderDelay(true);
      }, 800);
    } catch (err) {
      setData(err?.response?.data?.message?.data);
      errorHandler(err);
      setLoaderDelay(false);
    } finally {
      setIsLoading(false);
      setLoaderDelay(false);
    }
  };

  const debouncedSearch = useCallback(
    debounce((query) => fetchallcontest(query), 400),
    [currentPage, pageSize, status]
  );

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchItem(query);
    debouncedSearch(query);
  };

  const handleSort = (column, sortDirection) => {
    const srt = {
      [column.sortField]: sortDirection === "asc" ? -1 : 1,
    };
    setpayload((prev) => ({
      ...prev,
      sortObject: srt,
    }));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  useEffect(() => {
    fetchallcontest(searchItem);
  }, [currentPage, pageSize, status, refresh, isdelete, searchItem]);

  const deleteData = async (id) => {
    Swal.fire({
      title: "Are you sure you want to delete this contest?",
      text: "This action is irreversible and the contest will be permanently removed.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setisdelete(true);
          const res = await contestmanagerapi.delete({ id });

          if (res?.status === 200) {
            toast.success(res?.data?.message, { toastId: "success" });
            setData((prev) => {
              const updatedData = (prev.data || []).filter(
                (item) => item.id !== id
              );
              return {
                ...prev,
                data: updatedData,
                totalCount: prev.totalCount - 1,
              };
            });
            setisdelete(false);
          } else {
            toast.error(res?.data?.message, { toastId: "error" });
            setisdelete(false);
          }
        } catch (error) {
          console.error("Error deleting...", error);
          errorHandler(error);
          setisdelete(false);
        }
      }
    });
  };

  const updateStatus = async (id, newStatus) => {
    try {
      const res = await contestmanagerapi.changeStatus({
        id,
        status: newStatus,
      });

      if (res.status === 200) {
        toast.success(`Contest marked as ${newStatus}`);
        setRefresh(!refresh);
      } else {
        toast.error(res?.data?.message, { toastId: "error" });
      }
    } catch (err) {
      errorHandler(err);
    }
  };

  const handleStatusChange = (id, currentStatus) => {
    const newStatus = currentStatus === "upcoming" ? "running" : "upcoming";

    Swal.fire({
      title: `Change Contest Status`,
      text: `Are you sure you want to mark this contest as ${newStatus}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: `Yes, mark as ${newStatus}`,
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await updateStatus(id, newStatus);
      }
    });
  };

  const columns = [
    {
      name: "S.No.",
      width: "80px",
      center: true,
      cell: (row, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      name: "Name",
      selector: (row) => row.name || "NA",
      sortable: true,
      grow: 2,
      wrap: true,
      minWidth: "120px",
    },
    {
      name: "Contest Type",
      selector: (row) => row.contest_type,
      sortable: true,
      grow: 2,
      wrap: true,
      minWidth: "120px",
    },
    {
      name: "Prize Pool",
      selector: (row) => row.prize_pool,
      sortable: true,
      grow: 2,
      wrap: true,
      minWidth: "150px",
    },
    {
      name: "Total Spots",
      selector: (row) => row.total_spots,
      sortable: true,
      grow: 2,
      wrap: true,
      minWidth: "120px",
    },
    {
      name: "User Entry",
      selector: (row) => row.per_user_entry,
      sortable: true,
      grow: 2,
      wrap: true,
      minWidth: "120px",
    },
    {
      name: "Created At",
      sortField: "createdAt",
      sortable: true,
      minWidth: "129px",
      selector: (row) =>
        row?.created_at
          ? new Date(row.created_at).toLocaleDateString("en-US")
          : "NA",
    },

    {
      name: "Status",
      grow: 1,
      minWidth: "150px",
      center: true,
      cell: (row) => (
        <Tooltip title="Status" placement="top">
          <Chip
            sx={{
              background: "transparent",
            }}
            label={row.status.charAt(0).toUpperCase() + row.status.slice(1)}
            clickable
            onClick={() => handleStatusChange(row.id, row.status)}
          />
        </Tooltip>
      ),
    },
    {
      name: "Action",
      center: true,
      grow: 1,
      minWidth: "160px",
      cell: (row) => (
        <>
          <Tooltip title="View" placement="top">
            <IconButton
              color="primary"
              onClick={() => {
                navigate(`/contest/view/${row.id}`);
              }}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Edit" placement="top">
            <IconButton
              color="primary"
              onClick={() => {
                navigate(`/contest/edit/${row?.id}`);
              }}
            >
              <EditOutlined />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete" placement="top">
            <IconButton color="primary" onClick={() => deleteData(row.id)}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  console.log("data", data);
  return (
    <div>
      <Helmet>
        <title>List Contest Manager</title>
      </Helmet>
      <Card>
        <CardHeader
          titleTypographyProps={{ variant: "h4" }}
          title="Contest Manager"
        />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 2,
            px: 3,
            pt: 1,
          }}
        >
          <Input
            value={searchItem}
            placeholder="Search"
            onChange={handleSearchChange}
            endAdornment={
              searchItem && (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="clear search"
                    onClick={() => {
                      setSearchItem("");
                      fetchallcontest("");
                    }}
                  >
                    <CloseIcon sx={{textShadow:"none", background:"transparent"}} />
                  </IconButton>
                </InputAdornment>
              )
            }
            sx={{ minWidth: 250 }}
          />
          <Button
            size="large"
            type="submit"
            variant="contained"
            onClick={() => navigate("/contest/add")}
          >
            Add
          </Button>
        </Box>
        <CardContent>
          <DataTable
            customStyles={{
              headCells: {
                style: {
                  fontSize: "15px",
                  fontWeight: "bold",
                },
              },
            }}
            columns={columns}
            data={data}
            pagination
            paginationServer
            paginationTotalRows={totalPages}
            onChangePage={handlePageChange}
            paginationPerPage={pageSize}
            paginationRowsPerPageOptions={[10, 20, 50]}
            onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
              setPageSize(currentRowsPerPage);
              setCurrentPage(1);
            }}
            onSort={handleSort}
            progressPending={isLoading || !loaderDelay}
            progressComponent={<Loader />}
            className="custom"
          />
        </CardContent>
        <Dialog
          open={show}
          onClose={() => setShow(false)}
          className="popupbox-statis"
        >
          <DialogTitle>{warning}</DialogTitle>
          <DialogActions className="status-box-action">
            <Button
              variant="outlined"
              onClick={() => {
                setShow(false);
              }}
              color="primary"
            >
              Yes
            </Button>
            <Button
              variant="outlined"
              onClick={() => setShow(false)}
              color="primary"
            >
              No
            </Button>
          </DialogActions>
        </Dialog>
        {modalShow ? (
          <ViewBanner
            show={modalShow}
            onHide={() => setModalShow(false)}
            id={viewId}
          />
        ) : (
          ""
        )}
      </Card>
    </div>
  );
};

export default ListContestManager;
